// extracted by mini-css-extract-plugin
module.exports = {"footer":"_7322048"};